import React, { useState } from 'react';
import PCLayout from './components/Layout/Pc';
import './App.less';
import { IntlProvider } from 'react-intl';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';

const langMap = { zh: zhCN, en: enUS };

const App = () => {
  const [locale, setLocale] = useState('zh');

  return (
    <IntlProvider locale={locale} messages={langMap[locale] || zhCN}>
      <div className="app-container">
        <PCLayout setLocale={setLocale} locale={locale} />
      </div>
    </IntlProvider>
  );
};

export default App;
